<template>
      <div class="container" v-if="!noactive">
        <div class="row">
            <div class="col-12">
                <div class="bg-green">
                    <h1 class="text-center text-white text-watch">FALTA POCO PARA ENTREGARTE LA SORPRESA QUE TENEMOS PREPARADA</h1>
                    <div class="row justify-content-center contenedor-watch">
                        <div class="sombra-watch"></div>
                        <div class="col-md-9">
                            <div class="row watch">
                                <div class="col-3">
                                    <div class="time">
                                        <span class="text-white block">{{ days }}</span>
                                        <span class="text-white text-small digit">DÍAS</span>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="time">
                                        <p class="text-white block">{{ hours }}</p>
                                        <p class="text-white text-small digit">HORAS</p>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="time">
                                        <p class="text-white block">{{ minutes }}</p>
                                        <p class="text-white text-small digit">MINUTOS</p>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="time">
                                        <p class="text-white block">{{ seconds }}</p>
                                        <p class="text-white text-small digit">SEGUNDOS</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h2 class="text-center text-white text-hashtag mt-4 d-flex justify-content-center"><span class="hashtag-aqua">#</span> GANALEAMARZO</h2>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Countdown',
  data () {
    return {
      hours:0,
      days: 0,
      minutes: 0,
      seconds:0,
      datend: '2019-03-01T00:01',
      noactive: true,
    }
  },
  mounted(){
    setInterval(this.updateCounter,1000)
  },
  methods: {
    updateCounter(){
      let now = new Date();
      let end = new Date(this.datend);
      let distance = end - now;
      if(distance > 0){
        this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
        this.seconds = Math.floor((distance % (1000 * 60)) / 1000);
        this.noactive = false;
      }else{
        this.hours = 0;
        this.minutes = 0;
        this.days = 0;
        this.seconds = 0;
        this.noactive = true;
      }
    },
  }
}
</script>

<style scoped>

  .texto{
    font-size: 30px;
    color: red;
  }

.bg-green {
    background-image: url('https://res.cloudinary.com/dmx3pf3os/image/upload/v1550849631/bg-green.png');
    width: 100%;
    background-size: cover;
    padding: 20px;
    border-radius: 20px;
}
.text-watch {
    margin-top: 1%;
    margin-bottom: 3%;
    font-size: 177%;
    font-weight: 352;
    text-shadow:
        0.2px  0px 0px black,
        0px  0.2px 0px black,
        -0.2px  0px 0px black,
        0px -0.2px 0px black;
}
.text-hashtag {
    font-size: 199%;
    font-weight: 340;
}
.hashtag-aqua {
    color: aqua;
}
.contenedor-watch {
    position: relative;
}
.watch {
    border-radius: 500px;
    background-color: black;
    width: auto;
    position: relative;
}
.sombra-watch {
    position: absolute;
    height: 20px;
    width: 100%;
    left: 0px;
    bottom: -10px;
    background: -moz-radial-gradient(center, ellipse cover, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 60%); /* FF3.6-15 */
    background: -webkit-radial-gradient(center, ellipse cover, rgba(0,0,0,1) 0%,rgba(0,0,0,0) 60%); /* Chrome10-25,Safari5.1-6 */
    background: radial-gradient(ellipse at center, rgba(0,0,0,1) 0%,rgba(0,0,0,0) 60%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#a6000000', endColorstr='#00000000',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
}
.time .text-white {
    margin-bottom: 0;
    display: block;
    text-align: center;
}

@media (max-width:768px) {
    .watch {
        padding: 0px 30px 20px 30px;
    }
    .time .text-white {
        font-size: 32px;
    }
    .time .text-white.text-small {
        font-size: 10px;
    }
    .text-hashtag {
        font-size: 167%;
    }
    .text-watch {
        font-size: 122%;
    }
}
@media (min-width:768.1px) {
    .watch {
        padding: 0px 60px 20px 60px;
    }
    .time .text-white {
        font-size: 64px;
    }
    .time .text-white.text-small {
        font-size: 20px;
    }
}
</style>
